import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
import _ from 'lodash'

const tableHeaders = [
  'name',
  'teams',
  'email',
  'telephone',
  'workingHours',
  'hiringDate',
]

class EmployeesComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (_.size(this.props.employees) > 0) {
      return <div><Table employees={this.props.employees} headers={tableHeaders}></Table></div>
    }
    return <div>Loading</div>
  }
}

EmployeesComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  employees: PropTypes.object.isRequired,
}

export default EmployeesComponent
